/**
 * 表示二维空间中的矢量
 */
export class Vector {
    /**
     * 矢量的 x 坐标
     */
    x: number;
    /**
     * 矢量的 y 坐标
     */
    y: number;

    /**
     * 创建一个新的矢量
     * @param x - x 坐标值
     * @param y - y 坐标值
     */
    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    /**
     * 将当前矢量与另一个矢量相加
     * @param vector - 要添加的矢量
     * @returns 相加后的新矢量
     */
    add(vector: Vector): Vector {
        return new Vector(this.x + vector.x, this.y + vector.y);
    }

    /**
     * 将当前矢量乘以标量
     * @param scalar - 乘数
     * @returns 缩放后的新矢量
     */
    multiply(scalar: number): Vector {
        return new Vector(this.x * scalar, this.y * scalar);
    }

    /**
     * 判断当前矢量是否与另一个矢量相等
     * @param vector - 要比较的矢量
     * @returns 如果两个矢量的 x 和 y 坐标相等，则返回 true，否则返回 false
     */
    equals(vector: Vector): boolean {
        return this.x === vector.x && this.y === vector.y;
    }

    /**
     * 创建当前矢量的副本
     * @returns 当前矢量的一个新副本
     */
    clone(): Vector {
        return new Vector(this.x, this.y);
    }
}